<div class="_w-full">
    <div *ngIf="collapsableSearchInput" 
        class="_w-7 _h-7 _mr-nudge-4 _flex _items-center _justify-center _cursor-pointer _bg-primary-1 _rounded-full hover:_bg-primary-3 _transition-all-medium" 
        (click)="activateSearchInput()">
        <i class="fa-solid fa-magnifying-glass _text-white"></i>
    </div>

    <fieldset *ngIf="showSearchInput || !collapsableSearchInput" 
        class="_w-full _h-form-field _top-0 _left-0 _bg-transparent _flex _items-center"
        [ngClass]="{
            '_border-transparent' : showSearchInput,
            '_absolute' : collapsableSearchInput,
            '_relative' : !collapsableSearchInput
        }"
        [formGroup]="formGroup">
        <input 
            #searchTextInput
            class="_absolute _left-0 _w-full _pl-8 _bg-white _z-10 _input-rounded _h-form-field-fat _bg-transparent _border-primary-1 _outline-inset _shadow" 
            type="text" 
            placeholder="Search by property name or destination..."
            formControlName="searchTextValue"
            [(value)]="searchTerm">

        <i class="fa-regular fa-magnifying-glass _z-10 _px-4"></i>

        <i [ngClass]="{ 
            '_text-primary-1-tint-20 _pointer-events-none _cursor-default' : !searchTerm, 
            '_cursor-pointer' : searchTerm
        }"
        class="fa-light fa-xmark _z-10 _absolute _right-4" 
        (click)="clearSearchText()"></i>
    </fieldset>

    <div *ngIf="(collapsableSearchInput && showSearchInput && searchTerm && searchTerm.length > 1) || (!collapsableSearchInput && searchTerm && searchTerm.length > 1) "
        [ngClass]="{ '_absolute _w-full _z-10 _shadow' : !inline }"
        [ngStyle]="{'height' : 'calc(100dvh - 165px)'}"
        class="_border _border-primary-1 _bg-white _mt-4 _rounded-lg _p-4 _pt-0 _h-50vh _w-full _left-0 md:_max-h-100 _overflow-hidden">

        <app-loading-spinner [show]="loading"></app-loading-spinner>

        <div *ngIf="!loading" 
            class="_flex _gap-4 _h-full _overflow-hidden"
            [ngClass]="columnLayout ? '_flex-col' : '_flex-row'">

            <div class="_relative _overflow-hidden" [ngClass]="columnLayout ? '_w-full _max-h-50%' : '_w-1/2 _h-full'">
                <div class="_text-primary-1 _mb-2 _sticky _top-0  _pt-4 _bg-white _flex _justify-between">
                    <span>
                        <i class="fa-light fa-hotel _mr-1"></i>
                        <span class="_font-bold">Properties</span>
                    </span>
                    <span class="_ml-2 _text-md _text-primary-1-tint-50">({{ propertiesFiltered.length }} properties)</span>
                </div>
                <app-scroll-indicator [heightOffset]="61">
                    <ng-container *ngIf="searchTerm !== ''">
                        <ng-container *ngIf="propertiesFiltered.length === 0">
                            <div class="_bg-primary-1-tint-4 _mt-4 _rounded _p-4">
                                <app-property-inquiry
                                    headingText="No matching properties found"
                                ></app-property-inquiry>
                            </div>
                        </ng-container>

                        <ul class="_pt-3">
                            <li class="_p-2 _cursor-pointer hover:_bg-primary-1-tint-10 _flex _flex-col" 
                                *ngFor="let property of propertiesFiltered" 
                                (click)="openListing(property.listingId)">
                                <span [innerHtml]="boldMatchCharacters(property.name)"></span>
                                <div class="_flex _items-center _rounded">
                                    <span class="_text-sm _text-primary-1" [innerHtml]="boldMatchCharacters(property.locationName)"></span>
                                    <ng-container *ngIf="property.operatorName">
                                        <span class="_mx-2 _text-primary-1-tint-50">|</span>
                                        <span class="_text-sm _text-primary-1-tint-50" [innerHtml]="boldMatchCharacters(property.operatorName)"></span>        
                                    </ng-container>
                                </div>
                            </li>
                        </ul>
                    </ng-container>
                </app-scroll-indicator>
            </div>

            <div *ngIf="!columnLayout" class="_h-full _w-nudge-1 _bg-primary-1-tint-10 _mt-4"></div>

            <div class="_relative _overflow-hidden" [ngClass]="columnLayout ? '_w-full _max-h-50%' : '_w-1/2 _h-full'">
                <div class="_text-primary-1 _mb-2 _sticky _top-0  _pt-4 _bg-white _flex _justify-between">
                    <span>
                        <i class="fa-light fa-map-location-dot _mr-1"></i>
                        <span class="_font-bold">Destinations</span>   
                    </span>
                    <span class="_ml-2 _text-md _text-primary-1-tint-50">({{ destinationsFiltered.length }} destinations)</span>
                </div>
                <app-scroll-indicator [heightOffset]="61">
                    <ng-container *ngIf="searchTerm !== ''">
                        <!-- <div class="_pt-4" *ngIf="destinationsFiltered.length === 0">No matching destinations found</div> -->
                        <ng-container *ngIf="destinationsFiltered.length === 0">
                            <div class="_bg-primary-1-tint-4 _mt-4 _rounded _p-4">
                                <app-property-inquiry
                                    headingText="No matching destinations found"
                                    bodyText="Let us know what destination you require and we will get back to you within 48 hours."
                                ></app-property-inquiry>
                            </div>
                        </ng-container>
                        <ul class="_pt-4">
                            <li *ngFor="let destination of destinationsFiltered"  
                                class="_mb-1 _px-2 _cursor-pointer hover:_bg-primary-1-tint-10" 
                                (click)="locationSelected({
                                    name: destination.name,
                                    boundingBox: destination.boundingBox
                                })"
                                [innerHtml]="boldMatchCharacters(destination.name)">
                            </li>
                        </ul>
                    </ng-container>
                </app-scroll-indicator>
            </div>
        </div>
    </div>
</div>
